import { Component, OnInit } from '@angular/core';
import { faThumbsUp } from '@fortawesome/free-regular-svg-icons';
import { faThumbsUp as faThumbsUpFull } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-like',
  templateUrl: './like.component.html',
  styleUrls: ['./like.component.scss']
})
export class LikeComponent implements OnInit {

  faThumbsUp = faThumbsUp;
  faThumbsUpFull = faThumbsUpFull;
  isLike = true;

  constructor() { }

  ngOnInit(): void {
  }

  getLike(): void {
    this.isLike = !this.isLike;
  }

}
